import {RolPermission} from './rolPermission';
export class Rol {
    id:string;
    name:string;
    description:string;
    admin:boolean=false;
    client:boolean=false;
    
    permissions:RolPermission[] = [];

    constructor(other ?:Rol) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.description = other.description;
            this.admin = other.admin;
            this.permissions = other.permissions;
            this.client = other.client;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/rol.ts
 **/